import * as React from 'react';
import * as Styled from './Header.style'

const Header: React.FC<{}> = () => (
    <Styled.Banner m="0 auto" justifyContent="center"><Styled.Headline as="h1" fontSize={['36px', '48px']}>Suzi's Specialties</Styled.Headline></Styled.Banner>
);

export default Header;